import { Result } from "antd-v5";
import React from "react";

const PageComingSoon: React.FC = () => {
  return (
    <Result
      title="Coming soon!"
      subTitle="This feature is under construction, it will be live soon."
    />
  );
};

export default PageComingSoon;
